export const AVATAR_COLORS = {
  BLUE: 'blue',
  GREEN: 'green',
  RED: 'red',
  PURPLE: 'purple',
  ORANGE: 'orange',
  GREY: 'grey',
} as const;

export const AVATAR_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'x-large',
} as const;
